var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('DatePicker',{attrs:{"value":_vm.values,"placeholder":_vm.labelText,"type":"daterange"},on:{"input":_vm.changeDate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }